import React, { Fragment, Component, useRef, useState, useEffect } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Modal, ModalBody, ModalFooter, ModalHeader,
    Button, Label,
    Spinner,
    Progress,
    Table
} from "reactstrap"
import { Redirect, Link } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'
import { cancelToken } from '../../../../services/adapters/kepegawaian/menuService'

import moment from "moment"
import CreateBloc from '../Create/Blocs/CreateBloc'
import IndexBloc from '../Index/Blocs/IndexBloc'

import TableComponent from './Components/TableComponent'

let peg_uuid = JSON.parse(localStorage.getItem('userdata')) != null ? JSON.parse(localStorage.getItem('userdata')).employee_uuid : "";

const reformatDate = (date) => {
    const months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ];
    const d = new Date(date);
    let dt = d.getDate()
    if (dt < 10) {
        dt = '0'+dt
    }

    if (date) {
        return dt + " " + months[d.getMonth()] + " " + d.getFullYear();
    }

    return '-'
};


const ApproveView = (props) => {

    const indexBloc = new IndexBloc()
    const activeRef = useRef();
    const inactiveRef = useRef();
    const [period, setPeriod] = useState()
    const [modal, setmodal] = useState(false)
    const [fileUrl, setFileUrl] = useState("")
 
    const reloadInactiveRef = () => inactiveRef.current.setTokenAPI()

    const handleButtonExport = () => {
        setFileUrl("")
        setmodal(!modal)
        indexBloc.exportChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        setFileUrl(response.file_url) 
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        indexBloc.fetchExport({
            uuid: props.uuid
        })
    }

    useEffect(() => {
        indexBloc.fetchDetail({ uuid: props.uuid })
        indexBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                        setPeriod(result.data.response)
                    break;
                default:
                    break;
            }
        })
        return () => {
            indexBloc.detailChannel?.unsubscribe()
            indexBloc.exportChannel?.unsubscribe()
        }
    }, [])

    return (
        <Fragment>
            <Container fluid>
                <Card>
                    <CardBody>
                        <div className="float-end">
                            <Link to='/kepegawaian/pemberian_penghargaan.html' style={{ marginRight: 5 }}>
                                <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                            </Link>
                            <Button color="primary" style={{ marginRight: 5 }} onClick={() => handleButtonExport()}><i className="uil-file-download-alt"></i> Export Excel</Button>
                        </div>
                        <CardTitle>Detail Periode</CardTitle>
                        <CardSubtitle className="mb-3">Periode : {period?.award_period_year}</CardSubtitle>
                        <hr/>
                        <TableComponent ref={activeRef} handleInactiveSuccess={reloadInactiveRef} uuid={props.uuid}/>
                    </CardBody>
                </Card>
            </Container>


            <Modal
                isOpen={modal}
                role="dialog"
                autoFocus={true}
                centered={true}
                className="exampleModal"
                tabIndex="-1"
                toggle={() => {
                    setmodal(!modal)
                }}
            >
                <div className="modal-content">
                <ModalHeader
                    toggle={() => {
                        setmodal(!modal); setFileUrl("");
                    }}
                >
                    Export
                </ModalHeader>
                <ModalBody>
                    {
                        (fileUrl == "") ?
                            <div className="text-center">
                                <Spinner className="m-1" color="primary" />
                                <div>
                                    Memproses Data
                                </div>
                            </div> 
                            :
                            <>
                                <Row className='mb-3'>
                                    <label className="col-md-4">
                                        Jenis File
                                    </label>
                                    <Col md='8'>
                                        Excel (xlsx)
                                    </Col>
                                </Row>
                                <Row className='mb-3'>
                                    <label className="col-md-4">
                                        Waktu Generate
                                    </label>
                                    <Col md='8'>
                                        {moment(new Date()).format("DD/MM/YYYY HH:mm")}
                                    </Col>
                                </Row>
                                <Row className='mb-3'>
                                    <label className="col-md-4">
                                        Link
                                    </label>
                                    <Col md='8'>
                                        <a target={"_blank"} className="btn btn-success" href={fileUrl}>
                                            Download <i className="fa fa-download ms-1"></i>
                                        </a>
                                    </Col>
                                </Row>
                            </>
                    }
                </ModalBody>
                <ModalFooter>
                    <Button
                        type="button"
                        color="secondary"
                        onClick={() => {
                            setmodal(!modal); setFileUrl("");
                        }}
                    >
                    Kembali
                    </Button>
                </ModalFooter>
                </div>
            </Modal>


        </Fragment>
    )
}

class ApproveViewCode extends Component {

    source
    createBloc = new CreateBloc()
    defaultSize = 10
    
    constructor(props) {
        super(props)
        this.state = {
            detail: {}
        }
    }

    loadDetail = async () => {
        const query = {
            uuid: this.props.uuid
        }
        await this.createBloc.fetchDetail(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadDetail()
    }

    componentDidMount() {
        this.setTokenAPI()

        this.createBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ detail: result.data.response })
                    break
                default:
                    break
            }
        })

    }



    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Card>
                        <CardBody>
                            <div className="float-end">
                                <Link to='/kepegawaian/pemberian_penghargaan.html'>
                                    <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                </Link>
                            </div>
                            <CardTitle>Detail Periode</CardTitle>
                            <hr />    
                        </CardBody>
                    </Card>
                </Container>
            </Fragment>
        )
    }
}

export default ApproveView;